module.exports = __webpack_public_path__ + "img/SketchPng07a4a3009072907529c1357faabce0cac82dbb40d9a7839db9e3eb8940eccb12.22153deb.png";